module.exports = __webpack_public_path__ + "static/media/img1.0cd4bf81.jpg";